/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import React, { useState, useEffect, ReactNode } from "react";
import classnames from "classnames/bind";

import DoubleChevron from "components/icons/double-chevron";
import { setBodyOverflow } from "utils/dom.utils";
import styles from "./action-bar.module.css";

const cx = classnames.bind(styles);

interface ActionBarProps {
  isBannerPresent?: boolean;
  isDesktopSizeViewport: boolean;
  renderContents(onItemClickCallback: () => void): ReactNode;
}

const ActionBar: React.FC<ActionBarProps> = ({ renderContents, isBannerPresent, isDesktopSizeViewport }) => {
  const [isActive, setActive] = useState(true);

  useEffect(() => {
    if (!isDesktopSizeViewport) {
      isActive ? setBodyOverflow("hidden") : setBodyOverflow("auto");
    }
  }, [isDesktopSizeViewport, isActive]);

  const toggleActionBar = () => {
    setActive(!isActive);
  };

  const classes = cx("action-bar", { "is-active": isActive, "with-banner": isBannerPresent });

  return (
    <aside className={classes}>
      <div className={styles["action-bar-content"]}>
        {renderContents(() => !isDesktopSizeViewport && setActive(false))}
      </div>
      <div className={styles["toggle-action-bar"]} onClick={toggleActionBar} data-test-id="toggle-action-bar-btn">
        <DoubleChevron />
      </div>
    </aside>
  );
};

export default ActionBar;
